import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { company, customerData } from '../../../utilities/CustomerData'
import { apiURL } from '../../../utilities/URLs'
import { refreshAccessToken } from '../../../utilities/extensions'
import { tosText } from '../../Dashboard/DashboardScreens/DashboardTOS/DashboardTOSText'

function MultilineText({ text }) {
  const lines = text.split('\\n')

  const renderTextWithBold = (text) => {
    const parts = text.split(/(<b>|<\/b>)/)
    let isInBold = false

    return parts.map((part, index) => {
      if (part === '<b>') {
        isInBold = true
        return null
      } else if (part === '</b>') {
        isInBold = false
        return null
      } else {
        return isInBold ? <b key={index}>{part}</b> : part
      }
    })
  }

  return (
    <div>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {renderTextWithBold(line)}
          {index !== lines.length - 1 && <><br /><div style={{ height: '8px' }} /></>}
        </React.Fragment>
      ))}
    </div>
  )
}

export function RefundTOS({ applicationId, step, setStep }) {
  const navigate = useNavigate()

  const [hasScrolledToEnd, setHasScrolledToEnd] = useState(false)
  const [agreementChecked, setAgreementChecked] = useState(false)
  const [clientSignature, setClientSignature] = useState(customerData.customerLeadData.leadContact.contactName)
  const [spouseSignature, setSpouseSignature] = useState('')
  const [clientDate, setClientDate] = useState(new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }))
  const [spouseDate, setSpouseDate] = useState(new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }))
  const [uploadingTOS, setUploadingTOS] = useState(false)
  const [uploadedTOS, setUploadedTOS] = useState(false)

  const handleAccept = async () => {
    setUploadingTOS(true)

    const formData = new FormData()
    formData.append('customerTOSInfo', JSON.stringify({
      zohoId: customerData.customerLeadData.leadId,
      customerId: customerData.customerLeadData.leadContact.contactId,
      clientSignature: clientSignature,
      clientEmail: customerData.customerLeadData.leadContact.contactEmail,
      clientDate: clientDate,
      spouseSignature: spouseSignature,
      spouseDate: spouseDate
    }))

    const tosLinkResponse = await fetch(`${apiURL}/api/uploadTOS`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const tosLinkData = await tosLinkResponse.json()
    setUploadingTOS(false)

    if (tosLinkData.response.error) {
      if (tosLinkData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleAccept() : navigate('/', { state: { expired: true } })
      } else if(tosLinkData.response.error === 'IDme Missing.')
        navigate('/resyncIDme') 
        else 
        console.error(tosLinkData.response.error)
    } else {
      setUploadedTOS(true)
      setTimeout(() => {
        setUploadedTOS(false)
        customerData.customerTOSData = tosLinkData.response.customerTOSData
        setStep(step + 1)
      }, 2000)
    }

    setStep(step + 1)
  }

  useEffect(() => {
    window.scrollTo(0,0)
    document.title = `${company.companyName} | TOS Agreement`
  }, [])
  
  return (
    <div className='w-screen flex flex-col items-center'>
      <p className='font-bold text-center text-2xl max-sm:text-xl mb-10 max-sm:mb-4'>SETC Pros Client Agreement</p>
      <div className='w-11/12 border border-gray-300 p-4 rounded-md mb-10'>
        <h2 className='text-2xl font-bold mb-4'>Terms of Service</h2>
        <MultilineText text={tosText} />
        <div onClick={() => setAgreementChecked(!agreementChecked)} className='mt-12 flex items-center cursor-pointer'>
          <input
            type='checkbox'
            id='agreement'
            checked={agreementChecked}
            className='mr-2 lg:w-4 lg:h-4 w-6 h-6'
            onChange={(e) => setAgreementChecked(e.target.checked)}
          />
          <p>I agree to the SETC Pros Client Agreement</p>
        </div>
      </div>
      {agreementChecked && (
        <div className='w-11/12 mb-10'>
          <div className='mb-4'>
            <label className='block mb-2 font-medium'>Client Signature</label>
            <input
              type='text'
              placeholder='Sign Your Name'
              value={customerData.customerLeadData.leadContact.contactName}
              readOnly
              className='w-full p-2 border border-gray-300 rounded-md'
              required
            />
            <label className='block mb-2 font-medium mt-4'>Client Date</label>
            <input
              type='text'
              placeholder='Enter Date'
              value={clientDate}
              readOnly
              className='w-full p-2 border border-gray-300 rounded-md'
            />
          </div>
          {customerData.customerDocuments.marriedFilingJoint && (
            <div className='mb-4'>
              <label className='block mb-2 font-medium'>Spouse Signature</label>
              <input
                type='text'
                placeholder='Sign Your Name'
                value={spouseSignature}
                onChange={(e) => setSpouseSignature(e.target.value)}
                className='w-full p-2 border border-gray-300 rounded-md'
              />
              <label className='block mb-2 font-medium mt-4'>Spouse Date</label>
              <input
                type='text'
                placeholder='Enter Date'
                value={spouseDate}
                readOnly
                className='w-full p-2 border border-gray-300 rounded-md'
              />
            </div>
          )}
          {uploadingTOS && (
            <div className='flex flex-row items-center justify-center gap-2'>
              <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
              <p>Uploading SETC Pros Client Agreement...</p>
            </div>
          )}
          {uploadedTOS && (
            <p className='text-center mb-4'>SETC Pros Client Agreement Uploaded Successfully, Thank You!</p>
          )}
          <button
            onClick={handleAccept}
            disabled={(!customerData.customerDocuments.marriedFilingJoint ? !clientSignature : !clientSignature || !spouseSignature) || uploadingTOS}
            className={`w-full p-2 rounded-md text-white ${((!customerData.customerDocuments.marriedFilingJoint && clientSignature) ||
              (customerData.customerDocuments.marriedFilingJoint && clientSignature && spouseSignature))
              && !uploadingTOS
              ? 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'
              : 'bg-gray-400 cursor-not-allowed'
              }`}
          >
            Accept Terms
          </button>
        </div>
      )}
      <button onClick={() => setStep(step - 1)} className='px-10 bg-gray-200 rounded-lg p-2 mb-4'>
        Back
      </button>
    </div>
  )
}